/*TODO new code*/
import { Component, OnInit,
    ViewEncapsulation, Input, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { RiderNotesService } from './rider-notes.service';
import { T2CardComponent } from '../../../trip2-theme/components/t2-card/t2-card.component';

@Component({
    selector: 'app-rider-notes',
    templateUrl: './rider-notes.component.html',
    styleUrls: ['./rider-notes.component.scss']
})
export class RiderNotesComponent implements OnInit {

    private grid: GridOptions;
    private   newOption = false;
    private   editOption= false;
    private   noteid: number;


    @Input() riderid: number;

    @ViewChild('newnote') newBtn: ElementRef;
    @ViewChild('modalNote') ModalNote: T2CardComponent;

    constructor( protected service: RiderNotesService ) {
        this.grid = <GridOptions>{};

        this.configureGrid();
    }

    ngOnInit() {
        this.getTripNotes();
    }


    public getTripNotes() {
        this.service.getRiderNotes(this.riderid).subscribe(
            data => {
              if (this.grid) {
                if (this.grid.api) {
                  this.grid.api.setRowData(data);
                }
              }
            }
        );

    }

    private configureGrid() {
        const resize = this.grid;
        this.grid.columnDefs = [
            {
                headerName: '',
                width: 30,
                checkboxSelection: true

            },
            {
                headerName: 'Note',
                field: 'note.noteid',
                colId: 'noteid',
                width: 70,

            },
            {
                headerName: 'Date',
                field: 'note.date',
                colId: 'date',
                width: 120,
            },
            {
                headerName: 'Time',
                field: 'note.time',
                colId: 'consecutive',
                width: 120
            },
            {
                headerName: 'Note',
                field: 'note.description',
                colId: 'note',
                width: 400,
                cellStyle: {
                    'white-space': 'normal'
                }
            },
            {
                headerName: 'User',
                field: 'note.adminuser.fullname',
                colId: 'status',
                width: 120
            },
            {
                headerName: 'Type',
                field: 'note.noteregistertype.value',
                colId: 'status',
                width: 120
            }
        ];
        this.grid.getRowHeight = function(params) {
            return 25 * (Math.floor(params.data.note.description.length / 45) + 1);
        };
        this.grid.onGridReady = function () {
            resize.api.sizeColumnsToFit();
        };
    }


    /**
     *
     * @param $event
     */
    public onRowDoubleClickedTrip(event) {
        this.noteid       =   event.data.ridernoteid;
        this.newOption    =   false;
        this.editOption   =   true;
        this.ModalNote.open();
    }

    public newNoteForm() {
        this.editOption =  false;
        this.newOption =  true;
        this.ModalNote.open();
    }

    public closeAfterSave(data) {
        this.ModalNote.close();
        this.getTripNotes();
        this.newOption =  false;
        this.editOption =  false;
    }

    public closeNoteForm($event) {
        this.ModalNote.close();
        this.newOption =  false;
        this.editOption =  false;
    }

    public deletNote() {
        if (this.grid.api.getSelectedNodes().length > 0) {

            const data  =  this.grid.api.getSelectedNodes();
            const id    =  (data[0].data.note.noteid);
            this.service.deleteRiderNote(id).subscribe(
                res => {
                    this.getTripNotes();
                }
            );
        }


    }

}



// WEBPACK FOOTER //
// ./src/app/pages/riders/rider-notes/rider-notes.component.ts